import { render, staticRenderFns } from "./AddInjuryOnTheJob.vue?vue&type=template&id=c179c0e6&scoped=true"
import script from "./AddInjuryOnTheJob.vue?vue&type=script&lang=js"
export * from "./AddInjuryOnTheJob.vue?vue&type=script&lang=js"
import style0 from "./AddInjuryOnTheJob.vue?vue&type=style&index=0&id=c179c0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c179c0e6",
  null
  
)

export default component.exports